import { useRouter } from '@speedlo/hooks'
import { useObserver } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../atoms/RootProvider'
import { AccountPage } from '../pages/AccountPage'
import { ClientWaitPage } from '../pages/ClientWaitPage'
import { DashboardPage } from '../pages/DashboardPage'

export const MainRoute: React.FC = () => {
  const { auth } = useRoot()
  const { match } = useRouter<{ accountId: ID }>({
    path: '/admin/:accountId',
  })
  const accountId = match ? match.params.accountId : undefined

  return useObserver(() => {
    if (auth.isAdmin && !accountId) {
      return <DashboardPage />
    }
    if (!accountId) {
      return <ClientWaitPage />
    }
    return <AccountPage accountId={accountId} />
  })
}
